<template>
  <div class="homepage" >
    <div class="container-fluid">

      <!-- Hero Section -->
      <div class="row g-0 align-items-stretch hero-section">
        
        <!-- Left Text Content -->
        <div class="col-lg-4 col-md-12 order-2 order-lg-1">
          <div class="text-content-section h-100 d-flex align-items-center justify-content-center" style="background-color: #fad0faff;">
            <div class="content-wrapper text-center p-4 p-lg-5 position-relative">

              <!-- Desktop & Laptop Balloon - Conditionally shown -->
              <img
                v-if="showBalloon"
                src="@/assets/balloon.png"
                alt="Dreamy illustration with moon, stars, and balloons"
                class="img-fluid floating-balloon d-none d-md-block"
              />

              <p
                class="hero-subtitle mb-3 fw-bolder"
                style="font-family: 'Franklin Gothic Heavy', 'Arial Black', sans-serif; color: #ff5722;  white-space: nowrap;"
              >
                Create Storybooks Featuring the Little One You Love
              </p>

             
        <p class="mt-3 text-center description-text" style="font-family: 'Franklin Gothic Medium', 'Arial', sans-serif; color: rgb(30, 58, 138); max-width: min(90%, 500px); margin-left: auto; margin-right: auto; font-weight: 700;">
  Upload a kid's photo and we will craft a magical storybook, made just for them - printed and delivered to your home.
</p>
<button
  class="btn btn-lg fw-bold text-white rounded-pill mb-4 main-cta-btn"
  @click="$router.push('/books')"
>
  CREATE MY BOOK<br>
  <span class="free-preview-text">(Click Here for Free Preview)</span>
</button>
            </div>
          </div>
        </div>

        <!-- Center Image -->
        <div class="col-lg-4 col-md-12 order-1 order-lg-2">
          <div class="image-container position-relative rounded  d-none d-md-block  " style="background-color: #fad0faff; padding: 70px 20px 20px 20px !important;">
          
            
           <!-- <img
              src="@/assets/cloud.png"
              alt="Soft decorative cloud"
              class="position-absolute cloud-right d-none d-md-block"
            /> -->
            <img
              src="@/assets/Home page image.webp"
              class="main-product-img img-fluid rounded shadow"
              alt="Child playing with a personalized storybook"
            />
            <img
              src="@/assets/icon.png"
              alt="Create Your Story Now"
              class="position-absolute "
              style="width: 100px; bottom: -10px; right: -20px; z-index: 10;"
            />
          </div>

           <div class="image-container-mobile position-relative rounded d-md-none" 
       style="background-color: #fad0faff; padding: 50px 15px 10px 15px !important;">
    <!-- Balloon for mobile - placed here -->
    <img
      v-if="showMobileBalloon"
      src="@/assets/balloon.png"
      alt="Dreamy illustration with moon, stars, and balloons"
      class="img-fluid mobile-balloon d-md-none"
    />
    
    <img
      src="@/assets/Home page image.webp"
      class="main-product-img-mobile img-fluid rounded shadow"
      alt="Child playing with a personalized storybook"
      style="transform: translateY(-25px); margin-bottom: -15px;"
    />
     <img
    src="@/assets/icon.png"
    alt="Create Your Story Now"
    class="position-absolute d-md-none"
    style="width: 70px; bottom: -5px; right: -10px; z-index: 10;"
  />

  </div>

        </div>

        <!-- Right Perfect For Section -->
        <div class="col-lg-4 col-md-12 order-3 order-lg-3">
          <div class="perfect-for-section h-100 d-flex align-items-center justify-content-center p-4" style="background-color: #fad0faff;">
            <div class="content-wrapper w-100" style="margin-top: -.5rem;">
              <h4 class="section-title fw-bold mb-0 text-center " style="color: #1e3a8a;">Perfect For</h4><br>
              
              <div class="perfect-for-grid">
                <div class="row g-2">
                  <div class="col-6 col-lg-6" v-for="(item, index) in perfectForItems" :key="index">
                    <div
                      class="perfect-for-item text-center rounded border"
                      style="background-color: #f5f5b2ff; border-color: #f8f8acff;"
                    >
                      <i :class="['fs-5', 'mb-1', 'fixed-height-icon']" :style="item.style">{{ item.icon }}</i>
                      <h6 class="fw-bold mb-2 small" :style="{ color: item.titleColor }">{{ item.title }}</h6>
                      <p class="text-opacity-75 small fw-bold mb-0" style="color: #0f1011ff;">{{ item.text }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Reviews Section -->
   <section
  class="reviews-section py-4 " style="background-color: #fad0faff!important;"
>

  
        <div class="container">
          <h2 class="text-center fw-bold text-dark mb-3">
            Reviews
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-star-fill text-warning d-inline-block" viewBox="0 0 16 16">
    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-star-fill text-warning d-inline-block" viewBox="0 0 16 16">
    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-star-fill text-warning d-inline-block" viewBox="0 0 16 16">
    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-star-fill text-warning d-inline-block" viewBox="0 0 16 16">
    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
  </svg>
<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" 
     fill="currentColor" class="bi text-warning d-inline-block" 
     viewBox="0 0 16 16">
  <defs>
   
    <clipPath id="star-clip-3-4">
      <rect x="0" y="0" width="12" height="16" />
    </clipPath>
  </defs>
 
  <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592
           l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95
           l4.898-.696L7.538.792c.197-.39.73-.39.927 0
           l2.184 4.327 4.898.696c.441.062.612.636.282.95
           l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592
           L8 13.187l-4.389 2.256z"
        clip-path="url(#star-clip-3-4)" />
  
  <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592
           l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95
           l4.898-.696L7.538.792c.197-.39.73-.39.927 0
           l2.184 4.327 4.898.696c.441.062.612.636.282.95
           l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592
           L8 13.187l-4.389 2.256z"
        fill="none" stroke="currentColor" />
</svg>

  4.9
</h2>
          <!-- Loading State -->
          <div v-if="isLoadingReviews" class="text-center text-muted">
            <span class="spinner-border spinner-border-sm me-2"></span>
            Loading reviews...
          </div>
          
         <transition name="fade" mode="out-in">
      <div 
        :key="currentGroupIndex" 
        class="row g-4 justify-content-center position-relative"
        style="min-height: 300px;"
      >
        <div 
          class="col-xl-3 col-lg-3 col-md-6 col-sm-6" 
          v-for="(review, index) in visibleReviews" 
          :key="`${currentGroupIndex}-${index}`"
        >
          <!-- Inside reviews-section, update the card div -->
<div 
  class="card border-0 shadow-sm h-100 review-card" 
  style="height: 220px;"
  @mouseenter="enableScroll($event, index)" 
  @mouseleave="disableScroll($event, index)"
>
  <div class="card-body text-center p-3 d-flex flex-column" style="background-color: rgba(218, 179, 218, 0.9);">
    <div class="review-content-wrapper">
      <div class="stars mb-2 flex-shrink-0">
        <i
          v-for="star in 5"
          :key="star"
          :class="[
            'bi',
            star <= review.rating ? 'bi-star-fill' : 'bi-star',
            'text-warning'
          ]"
        ></i>
        <span class="ms-1 small text-muted">
          {{ review.rating?.toFixed(1) || '5.0' }}
        </span>
      </div>
      <p 
        class="fst-italic text-muted small text-start review-text" 
        style="text-align: justify; hyphens: auto;"
      >
        "{{ review.review || '' }}"
      </p>
      <p class="review-footer mt-auto text-dark fw-semibold reviewer-name">
        - {{ review.name || 'Anonymous' }}
      </p>
    </div>
  </div>
</div>
        </div>
      </div>
    </transition>
          
  </div>
</section>

      
     <!-- Trust Section -->
<section class="py-4">
  <div class="container">
    <div class="row g-3 justify-content-center">
      <!-- Private by Design Card -->
      <div class="col-md-5 col-sm-10">
        <div class="card text-center border-0 shadow-sm bg-secondary bg-opacity-25">
          <div class="card-body">
            <!-- Shield Lock Icon -->
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="fs-2 text-primary mb-3" viewBox="0 0 16 16" style="vertical-align: -0.125em;">
              <path d="M5.338 1.59a61 61 0 0 0-2.837.856.48.48 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.7 10.7 0 0 0 2.287 2.233c.346.244.652.42.893.533q.18.085.293.118a1 1 0 0 0 .101.025 1 1 0 0 0 .1-.025q.114-.034.294-.118c.24-.113.547-.29.893-.533a10.7 10.7 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.8 11.8 0 0 1-2.517 2.453 7 7 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7 7 0 0 1-1.048-.625 11.8 11.8 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 63 63 0 0 1 5.072.56"/>
              <path d="M9.5 6.5a1.5 1.5 0 0 1-1 1.415l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99a1.5 1.5 0 1 1 2-1.415"/>
            </svg>
            <h5 class="fw-bold text-dark">Private by Design</h5>
            <p class="text-muted">Photos are used only to create your book.</p>
          </div>
        </div>
      </div>

      <!-- Crafted to Last Card -->
      <div class="col-md-5 col-sm-10">
        <div class="card text-center border-0 shadow-sm bg-secondary bg-opacity-25">
          <div class="card-body">
            <!-- Gem Icon -->
           <svg xmlns="http://www.w3.org/2000/svg" 
     width="32" height="32" 
     fill="currentColor" 
     class="fs-2 text-primary mb-3" 
     viewBox="0 0 16 16" 
     style="vertical-align: -0.125em;">
  <path d="M3.1.7a.5.5 0 0 1 .4-.2h9a.5.5 0 0 1 .4.2l2.976 3.974c.149.185.156.45.01.644L8.4 15.3a.5.5 0 0 1-.8 0L.1 5.3a.5.5 0 0 1 0-.6z
           M10.853 4.489l.961-2.989H4.186l.963 2.995z
           M5.47 5.495L8 13.366l2.532-7.876z
          
           M1.499 5.5l5.113 6.817-2.192-6.82z
           M9.388 12.317l5.123-6.83-2.928.002z"/>
</svg>

            <h5 class="fw-bold text-dark">Crafted to Last</h5>
            <p class="text-muted">High-quality binding and vivid images.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
    </div>
  </div>
</template>

<script>
const base = "https://api.craftmystories.com";
export default {
  name: "HomePage",
  data() {
    return {
      perfectForItems: [
        {
          icon: "🎁",
          title: "Personalized Gift",
          text: "Birthdays, Holidays",
          style: "color: #ff3300ff;",
          titleColor: "#1e3a8a"
        },
        {
          icon: "❤️",
          title: "Moral Teachings",
          text: "Kindness, Courage",
          style: "color: #ff0000;",
          titleColor: "#1e3a8a"
        },
        {
          icon: "🎀" ,
          title: "Keepsake",
          text: "Family bonding",
          style: "color: #1e3a8a;",
          titleColor: "#1e3a8a"
        },
        {
         icon: "🎨",
          title: "Hobbies & Fun",
          text: "Sports, Art",
          style: "color: #ff4757; font-size: 2rem;",
            titleColor: "#1e3a8a"
        },
        {
          icon: "📸", 
          title: "Relive Childhood",
          text: "With Photos Of Younger Self",
          style: "color: #00bcd4;",
          titleColor: "#1e3a8a"
        },
        {
          icon: "🎉", 
          title: "Special Occasions",
          text: "Celebrations, Festivals",
          style: "color: #ff9800;",
          titleColor: "#1e3a8a"
        }
      ],
   allReviews: [], 
      visibleReviews: [], 
      currentIndex: 0,
       currentSlot: 0,
       currentGroupIndex: 0,
      groups: [],
      transitionInterval: null,
      isLoadingReviews: false,
    
      showBalloon: true,
      showMobileBalloon: true
    };
  },
  mounted() {
    this.checkBalloonVisibility();
    window.addEventListener('resize', this.checkBalloonVisibility);
      this.fetchHomePageReviews();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkBalloonVisibility);
     this.stopTransition();
  },
   computed: {
    visibleReviews() {
      
      if (this.groups.length > 0) {
        return this.groups[this.currentGroupIndex] || [];
      }
      return [];
    }
  },
  methods: {

    enableScroll(event, slotIndex) {
  const reviewText = event.currentTarget.querySelector('.review-text');
  if (reviewText) {
    reviewText.style.overflowY = 'auto';
    reviewText.style.maxHeight = '120px'; 
    reviewText.style.paddingRight = '4px';
  }
},

disableScroll(event, slotIndex) {
  const reviewText = event.currentTarget.querySelector('.review-text');
  if (reviewText) {
    reviewText.style.overflowY = 'hidden';
    reviewText.style.paddingRight = '0';
  }
},
    checkBalloonVisibility() {
      const width = window.innerWidth;
      
      if (width < 768) {
        this.showMobileBalloon = true;
      } else {
        this.showMobileBalloon = false;
      }
      
      
      if (width >= 768 && width < 900) {
        this.showBalloon = false;
      } else if (width >= 900) {
        this.showBalloon = true;
      }
    },

   async fetchHomePageReviews() {
      this.isLoadingReviews = true;
      try {
        const url = new URL(`${base}/api/reviews/approved`);
        url.searchParams.append("limit", 16);
        
        const response = await fetch(url);
        
        if (!response.ok) throw new Error("Failed to fetch reviews");
        
        const data = await response.json();
         this.allReviews = data.items.map(item => ({
          id: item.id,
          review: item.review || "",
          name: item.name || "Anonymous",
          rating: item.rating || 5
        }));
        
      
      if (this.allReviews.length < 4) {
          const fallbacks = [
            { id: 'fallback-1', review: "The quality is exceptional. Seeing my daughter's face on the pages made storytime magical!", name: "Diya Patel", rating: 5 },
            { id: 'fallback-2', review: "My son immediately connected with the hero because it was him! Best gift ever!", name: "Ethan Miller", rating: 4.5 },
            { id: 'fallback-3', review: "Photo integration looks perfect! A wonderful way to encourage reading.", name: "Atithi", rating: 5 },
            { id: 'fallback-4', review: "The personalization was spot-on! My nephew couldn't believe he was the star of the story.", name: "Rachel Kim", rating: 5 }
          ];
          
         
          while (this.allReviews.length < 12) {
            this.allReviews.push(fallbacks[this.allReviews.length % fallbacks.length]);
          }
        }
       
        this.createGroups();
        
       
        this.startTransition();
        
      } catch (err) {
        console.error("Error fetching reviews:", err);
       
        this.allReviews = [
          { id: 'fallback-1', review: "The quality is exceptional. Seeing my daughter's face on the pages made storytime magical!", name: "Diya Patel", rating: 5 },
          { id: 'fallback-2', review: "My son immediately connected with the hero because it was him! Best gift ever!", name: "Ethan Miller", rating: 4.5 },
          { id: 'fallback-3', review: "Photo integration looks perfect! A wonderful way to encourage reading.", name: "Atithi", rating: 5 },
          { id: 'fallback-4', review: "The personalization was spot-on! My nephew couldn't believe he was the star of the story.", name: "Rachel Kim", rating: 5 },
          { id: 'fallback-5', review: "Amazing quality and perfect gift for my niece!", name: "Priya Sharma", rating: 5 },
          { id: 'fallback-6', review: "My kids love seeing themselves in the story!", name: "Michael Chen", rating: 4.8 },
          { id: 'fallback-7', review: "Beautiful illustrations and great personalization.", name: "Sarah Williams", rating: 5 },
          { id: 'fallback-8', review: "Fast delivery and excellent customer service.", name: "David Brown", rating: 4.7 }
        ];
        


       
        this.createGroups();
        this.startTransition();
      } finally {
        this.isLoadingReviews = false;
      }
    },
     createGroups() {
      this.groups = [];
      for (let i = 0; i < this.allReviews.length; i += 4) {
        this.groups.push(this.allReviews.slice(i, i + 4));
      }
      
      this.currentGroupIndex = 0;
    },
    
    
    
    startTransition() {
    
      this.stopTransition();
      
      if (this.groups.length > 1) {
        this.transitionInterval = setInterval(() => {
          this.transitionAllCards();
        }, 12000);
      }
    },
    
    stopTransition() {
      if (this.transitionInterval) {
        clearInterval(this.transitionInterval);
        this.transitionInterval = null;
      }
    },
    
     transitionAllCards() {
      if (this.groups.length <= 1) return;
      
      // Move to next group
      this.currentGroupIndex = (this.currentGroupIndex + 1) % this.groups.length;
      
      // Force Vue to recognize the change
      this.$forceUpdate();
    },
   
    }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;1,400&display=swap');
@import url('https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.css');

.homepage {
  font-family: 'Montserrat', sans-serif;
  background-color: #fad0faff;
  
}
.bg-light-grey {
  background-color: #f3e5e5ff !important;
}

.max-width-320 {
  max-width: 320px;
}

.free-preview-text {
  font-size: 0.8rem !important;
  font-weight: 700;
  letter-spacing: 0.5px;
  opacity: 0.9;
}

.card-body svg {
  display: inline-block;
  vertical-align: -0.125em;
  fill: currentColor;
}

.fs-2 {
  font-size: 1.5rem !important;
}

.text-primary {
  color: #0d6efd !important;
}

.card-body svg.text-primary {
  color: inherit;
}


/* Base Button Styling */

.main-cta-btn {
  font-family: 'Verdana', sans-serif !important;
  font-weight: 700;
  letter-spacing: 0.8px;
  padding: 1rem 3rem;
  font-size: 1.3rem;
  white-space: nowrap;
  display: inline-block;
  min-width: 280px;
  background-color: #28a745;
  border: none;
  color: white;
  box-shadow: 0 6px 0 #1e7e34; 
  transition: all 0.2s ease;
  position: relative;
  animation: highlight-pulse 2.5s infinite;
}

/* Hover: lift and brighten (desktop only) */
.main-cta-btn:hover {
  background-color: #2ecc71;
  transform: translateY(-2px);
  box-shadow: 0 8px 0 #1e7e34;
  animation-play-state: paused;
}

/* Active: press down (works on both desktop & touch) */
.main-cta-btn:active {
  transform: translateY(4px);
  box-shadow: 0 2px 0 #1e7e34;
}

/* Pulse animation (defined once, used everywhere) */
@keyframes highlight-pulse {
  0% { transform: scale(1); }
  70% { transform: scale(1.05); } 
  100% { transform: scale(1); }
}

/* Mobile adjustments: only size, no animation override */
@media (max-width: 767.98px) {
  .main-cta-btn {
    min-width: 240px;
    font-size: 1.1rem;
    padding: 0.8rem 1.5rem;
    box-shadow: 0 4px 0 #1e7e34;
  
  }
}
/* Review text with scroll */
.review-text {
  overflow-y: hidden;
  flex: 1; /* Takes remaining space */
  text-align: justify;
  hyphens: auto;
  line-height: 1.3;
  font-size: 0.85rem;
  margin-bottom: 0 !important; 
  padding-bottom: 0 !important;
  max-height: 90px;
}

.reviewer-name {
  flex-shrink: 0;
  font-size: 0.85rem;
  margin-top: auto !important;
  padding-top: 0.25rem;
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
}

.review-text::-webkit-scrollbar {
  width: 4px;
}

.review-text::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 10px;
}

.review-text::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.review-text::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}


.review-content-wrapper {
  display: flex;
  flex-direction: column;
  height: 80%;
  width: 100%;
}


.stars i {
  transition: all 0.3s ease;
}


.review-card {
  transition: box-shadow 0.3s ease;
}

.review-card:hover {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1) !important;
}





.fade-enter-active {
  animation: fadeInUp 0.8s cubic-bezier(0.215, 0.61, 0.355, 1) both;
}

.fade-leave-active {
  animation: fadeOutDown 0.6s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes fadeOutDown {
  0% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  100% {
    opacity: 0;
    transform: translateY(-30px) scale(0.95);
  }
}

/* Review card styling with grey background */
.review-card {
  height: 200px !important;
  min-height: 200px !important;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  background-color: #f8f9fa !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
}

.review-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1) !important;
  background-color: #e9ecef !important;
}

.review-card .card-body {
  padding: 0.75rem !important;
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 0.375rem;
  background-color:  rgba(218, 179, 218, 0.9);
  transition: background-color 0.3s ease;
}

.review-card:hover .card-body {
  background-color: #d6b9da;
}

/* Review text styling */
.review-text {
  overflow-y: hidden;
  flex: 1;
  text-align: justify;
  hyphens: auto;
  line-height: 1.4;
  font-size: 0.85rem;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  max-height: 90px;
  color: #495057 !important;
  transition: color 0.3s ease;
}

.review-card:hover .review-text {
  color: #212529 !important;
}

.reviewer-name {
  flex-shrink: 0;
  font-size: 0.85rem;
  margin-top: auto !important;
  padding-top: 0.5rem;
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
  color: #343a40;
}

/* Stars styling */
.stars i {
  transition: all 0.3s ease;
  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.1));
}

.review-card:hover .stars i {
  transform: scale(1.1);
  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.15));
}
.review-card .card-body {
  padding: 0.75rem !important; /* Reduced padding */
  display: flex;
  flex-direction: column;
  height: 100%;
}
.review-card:hover {
  transform: translateY(-5px);
}




/* Button styling */
.btn-success {
  font-size: 1.3rem;
  letter-spacing: 0.5px;
   background-color: #218838;
  transition: all 0.3s ease;
}

.btn-success:hover {
  transform: translateY(-3px);
   background-color: #218838;
}

.hero-subtitle {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.02rem;
  font-weight: 500;
  letter-spacing: 0.3px;
  line-height: 1.5;
  margin-top: 1rem;
  color: #e91e63;
}

/* PERFECT FOR styling */
.perfect-for-item {
  background-color: #ffc107 !important;
  border-color: #ffc107 !important;
  transition: all 0.2s ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  padding: 0.3rem 0.5rem 0.75rem 0.5rem !important; 
  height: 100%;
}

.perfect-for-item p.small {
  font-size: 0.7rem !important; 
  line-height: 1.1 !important;
  white-space: normal;
}

.perfect-for-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.perfect-for-item i {
  display: flex !important;
  align-items: center;
  justify-content: center;
  font-size: 2.2rem;
  width: 52px;
  height: 52px;
  min-height: 52px;
  margin-top: 0 !important;
  line-height: 1;
  text-align: center;
  transform: none !important;
  rotate: 0deg !important;
  font-style: normal;
  vertical-align: middle;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  transition: transform 0.2s ease-in-out;
}

.perfect-for-item i {
  font-family: "Segoe UI Emoji", "Apple Color Emoji", "Noto Color Emoji", sans-serif;
}

.perfect-for-item h6 {
  margin-top: 0 !important;
  margin-bottom: 0.3rem !important;
  line-height: 1.1 !important;
}

.perfect-for-item i:hover {
  transform: scale(1.05);
}

.fixed-height-icon {
  display: inline-block; 
  height: 30px;
  line-height: 30px; 
}
.reviews-section {
  background-color: #dce9f7ff;
  
}

/* Floating animations */
.cloud-right {
  width: 120px;
  left: -80px;
  top: 20px;
  z-index: 5;
  opacity: 0.9;
  animation: floatCloud 6s ease-in-out infinite;
}

@keyframes floatCloud {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}


.content-wrapper {
  position: relative;
}

@keyframes floatUpDown {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0px);
  }
}


.floating-balloon {
  position: absolute !important;
  animation: floatUpDown 4s ease-in-out infinite;
  transform-origin: center;
}

@supports (-webkit-touch-callout: none) {
  .reviews-section {
    background-color: #dce9f7ff;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}
@media (min-width: 768px) and (max-width: 991.98px) {
  
  .floating-balloon {
    top: 15px;
    left: -30px;
    width: 45px;
  }
  .cloud-right {
    display: none !important;
  }
}
.reviews-section {
  background-color: #dce9f7ff;
}
.review-card .card-body {
    background-color: #d6b9da !important;
  }

@media (min-width: 992px) and (max-width: 1199.98px) {
  .floating-balloon {
    top: 10px;
    left: 30px;
    width: 50px;
  }
  .reviews-section {
      background-color: #dce9f7ff;
      
    }
  
}

/* Large Desktop (1200px+) - Moved further right */
@media (min-width: 1200px) {
  .floating-balloon {
    top: 1px;
    left: 25px;
    width: 45px;
  }
   .description-text {
    font-size: 0.9rem !important;       
    max-width: 95% !important;            
    text-align: left;                     
    margin-left: 0 !important;              
    margin-right: 0 !important;
    padding-left: 8px;                      
    padding-right: 8px;
  }
  .cloud-right {
  width: 120px;
  left: -80px;
  top: 20px;
  z-index: 5;
  opacity: 0.9;
  animation: floatCloud 6s ease-in-out infinite;
}
.reviews-section {
      background-color: #dce9f7ff;
      
    }
}

/* Hide balloon on very small desktop screens */
@media (min-width: 768px) and (max-width: 899.98px) {
  
  .cloud-right {
    display: none !important;
  }
  .reviews-section {
      background-color: #dce9f7ff;
      
    }
}

/* ========== MOBILE RESPONSIVE STYLES ========== */

.mobile-balloon {
  position: absolute !important;
  width: 50px !important;
  top: 8px !important;
  left: 8px !important;
  z-index: 10;
  animation: floatUpDown 3s ease-in-out infinite;
}
@media only screen and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) {
  .description-text {
    font-size: 14px;
  }
}

/* Ensure balloon shows on all mobile sizes */
@media (max-width: 767.98px) {

  .main-product-img-mobile {
    transform: translateY(-30px);
    margin-bottom: -20px;
  }
  
  .image-container-mobile {
    padding: 45px 12px 5px 12px !important;
    min-height: 280px;
    margin-top: -5px !important;
  }
  .mobile-balloon {
    display: block !important;
    width: 45px !important;
    top: 10px !important;
    left: 10px !important;
  }

.btn.rounded-pill {
  font-size: 1rem !important;
  padding: 0.6rem 1.5rem !important;
  min-width: 220px !important;
  margin-bottom: 0.5rem !important;
}


.content-wrapper p.mt-3 {
  margin-top: 0.25rem !important;
}
.col-lg-4.order-2 .content-wrapper {
  padding-bottom: 0.5rem !important;
}
  .image-container {
     padding: 15px 10px 10px 10px !important; 
    position: relative;
    min-height: 300px;
    margin-top: -15px !important;
  }

   .create-book-btn {
    font-size: 0.9rem !important;
    padding: 0.7rem 1.2rem !important;
    min-width: 200px !important;
    margin-top: -20px !important; 
  }
  .cloud-right {
    display: none !important;
  }

  .btn-success {
    font-size: 1.1rem;
    padding: 0.8rem 2rem;
    min-width: 250px;
     background-color: #218838;
  }

  .hero-subtitle {
    font-size: 0.9rem;
    text-align: center;
     margin-top: -1rem !important; /* Move tagline up more */
    margin-bottom: 0.5rem !important;
  }

  .perfect-for-section {
    padding-top: 0.5rem !important;
  padding-bottom: 2rem !important;
  }

  .section-title.mb-1 {
    text-align: center !important;
    margin-bottom: 1.5rem !important;
  }

  .description-text {
    font-size: 0.8rem !important;        
    max-width: 95% !important;            
    text-align: left;                     
    margin-left: 0 !important;              
    margin-right: 0 !important;
    padding-left: 8px;                       
    padding-right: 8px;
  }

  .perfect-for-item {
    padding: 0.5rem 0.3rem 0.5rem 0.3rem !important;
    margin-bottom: 0.5rem;
  }

  .perfect-for-item i {
    font-size: 1.8rem;
    width: 40px;
    height: 40px;
    min-height: 40px;
  }

  .reviews-section {
    padding: 2rem 1rem !important;
   background-colour: #dce9f7ff;

;
  }

  .review-card {
    margin-bottom: 1rem;
  }
}

/* Extra small mobile devices - adjust balloon size but keep it visible */
@media (max-width: 399.98px) {
  .mobile-balloon {
    width: 40px !important;
    top: 8px !important;
    left: 8px !important;
  }
#EAF2FBFF-section {
      background-color:#EAF2FBFF
 !important;
      
    }
  .image-container {
    padding: 45px 12px 12px 12px !important;
    min-height: 280px;
  }

  .btn-success {
    font-size: 1rem;
    padding: 0.7rem 1.5rem;
    min-width: 220px;
     background-color: #218838;
  }
}

/* For small mobile screens */
@media (max-width: 576px) {
  .mobile-balloon {
    width: 45px !important;
    top: 30px !important;
    left: 10px !important;
  }

  .image-container {
    padding: 45px 12px 12px 12px !important;
    min-height: 280px;
  }

  .btn-success {
    font-size: 1rem;
    padding: 0.7rem 1.5rem;
    min-width: 220px;
     background-color: #218838;
  }
}


.d-md-none.mobile-balloon {
  display: block !important;
  opacity: 1 !important;
  visibility: visible !important;
}

@supports (-webkit-touch-callout: none) {
  @media (max-width: 430px) {
    .reviews-section {
      background-color: #dce9f7ff;
      
    }
     .hero-subtitle {
    font-size: 0.9rem;
    text-align: center;
     margin-top: -1rem !important;
    margin-bottom: 0.5rem !important;
  }
  }
}

</style>
